import { call, put, takeLatest } from 'redux-saga/effects';

import { Peripherals } from '../../../entities/Peripherals/interfaces';
import { PeripheralsService } from '../../../entities/Peripherals/service';
import { SecurityGate } from '../../../entities/SecurityGate/interfaces';
import { SecurityGateService } from '../../../entities/SecurityGate/services';
import {
  getPheripError,
  getPheripRequest,
  getPheripSuccess,
  getSecGateRequest,
  getSecGateError,
  getSecGateSuccess,
} from './actions';
import { GET_PERIPHERALS_REQUEST, GET_SECURITY_GATE_REQUEST } from './constants';

function* getSecGate(action: ReturnType<typeof getSecGateRequest>) {
  try {
    const response: SecurityGate[] = yield call(SecurityGateService.getSGates, action.params);

    yield put(getSecGateSuccess(response));
  } catch (error: any) {
    yield put(getSecGateError(error));
  }
}

function* getPeripherals(action: ReturnType<typeof getPheripRequest>) {
  try {
    const response: Peripherals[] = yield call(PeripheralsService.getPeripherals, action.payload);

    yield put(getPheripSuccess(response));
  } catch (error: any) {
    yield put(getPheripError(error));
  }
}

export function* headerSagaWatcher() {
  yield takeLatest(GET_SECURITY_GATE_REQUEST, getSecGate);
  yield takeLatest(GET_PERIPHERALS_REQUEST, getPeripherals);
}
